import { render, staticRenderFns } from "./HealthTable.vue?vue&type=template&id=1e94487c&"
import script from "./HealthTable.vue?vue&type=script&lang=js&"
export * from "./HealthTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports